import axios from 'axios';
import {IInvestmentContact} from "@/shared/model/investement-contact.model";

const baseApiUrl = 'api/admin/investment/contact-us';

export default class InvestmentContactService {
    public retrieve(page: number, itemPerPage: number, searchTerm: string, status: string): Promise<any> {
        let url = baseApiUrl;

        const params = new URLSearchParams();

        if (page != null) {
            params.append('page', page.toString());
        }
        if (status != null) {
            params.append('status', status.toString());
        }
        if (searchTerm) {
            params.append('email', searchTerm);
        }
        if (itemPerPage) {
            params.append('size', itemPerPage.toString());
        }
        const queryString = params.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        return new Promise<any>((resolve, reject) => {
            axios
                .get(url)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public delete(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .delete(`${baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public create(entity: IInvestmentContact): Promise<IInvestmentContact> {
        return new Promise<IInvestmentContact>((resolve, reject) => {
            axios
                .post(`${baseApiUrl}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public updateStatus(status: string, publicId: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .put(`${baseApiUrl}/${publicId}/${status.toLowerCase()}`)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public assignUser(userPublicId: string, publicId: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .put(`${baseApiUrl}/${publicId}/assign`,
                    {
                        "userPublicId": userPublicId
                    }
                )
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public update(entity: IInvestmentContact): Promise<IInvestmentContact> {
        return new Promise<IInvestmentContact>((resolve, reject) => {
            axios
                .put(`${baseApiUrl}/${entity.id}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public partialUpdate(entity: IInvestmentContact): Promise<IInvestmentContact> {
        return new Promise<IInvestmentContact>((resolve, reject) => {
            axios
                .patch(`${baseApiUrl}/${entity.id}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
